<template>
  <div class="line-item-actions__select">
    <select
      class="line-item-actions__select-qty"
      @change="(e) => $emit('change', e)"
    >
      <option value="0">0</option>
      <option
        v-for="value in stock || 10"
        :key="value"
        :value="value"
        :selected="selected === value"
      >
        {{ value }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  props: {
    stock: {
      type: Number,
      default: 10,
    },
    selected: {
      type: Number,
      default: 1,
    },
  },
}
</script>
